import { useContext } from 'react'

import { Context } from '@/Providers'

function usePageIdContext() {
  return useContext(Context)
}

export { usePageIdContext }
